const settings = {
  octaves: 4,
  volumes: 8,
  phrases: 8 * 8,
  chains: 8 * 8,
  songs: 8,
  matrixLength: 16,
  chainChannels: 4,
  startOffset: '+0.1',
  startOffsetDouble: '+0.5',
  bpm: 200,
  subdivision: '8n'
}

export default settings



// WEBPACK FOOTER //
// ./src/iframe/src/settings.js